// error.store.ts
import { Injectable, computed, signal } from '@angular/core';
import { ErrorState } from '@state/error/error.state';

@Injectable({
  providedIn: 'root',
})
export class ErrorStore {
  // Private state
  private readonly state = signal<ErrorState>({
    type: null,
    isOpen: false,
  });

  // Public selectors (computed signals)
  readonly isOpen = computed(() => this.state().isOpen);
  readonly errorType = computed(() => this.state().type);
  readonly title = computed(() => {
    switch (this.state().type) {
      case 'unauthorized':
        return 'Accès refusé';
      case 'notFound':
        return 'Page non trouvée';
      default:
        return '';
    }
  });
  readonly message = computed(() => {
    switch (this.state().type) {
      case 'unauthorized':
        return "Vous n'êtes pas autorisé à accéder à cette page. Veuillez contacter votre administrateur si vous pensez qu'il s'agit d'une erreur.";
      case 'notFound':
        return "La page recherchée n'a pas pu être trouvée.";
      default:
        return 'Erreur inconue';
    }
  });
  readonly icon = computed(() => {
    switch (this.state().type) {
      case 'unauthorized':
        return 'block';
      case 'notFound':
        return 'error';
      default:
        return '';
    }
  });

  // Actions
  showUnauthorized() {
    this.state.update((state) => ({
      ...state,
      type: 'unauthorized',
      isOpen: true,
    }));
  }

  showNotFound() {
    this.state.update((state) => ({
      ...state,
      type: 'notFound',
      isOpen: true,
    }));
  }

  close() {
    this.state.update((state) => ({ ...state, isOpen: false, type: null }));
  }
}
